import Button from "rsuite/Button";
import Message from "rsuite/Message";
import { OrderListDeliverySetting } from "../../models/orderListModels";
import { getOrderListSettingsErrors } from "../../helpers/orderListSettingsHelper";

interface Props {
  draftSettings: OrderListDeliverySetting[];
  activeCategories: string[];
  open: boolean;
  saving: boolean;
  error: unknown;
  onClose: () => void;
  onSave: (settings: OrderListDeliverySetting[]) => void;
  onChange: (settings: OrderListDeliverySetting[]) => void;
}

const deliveryDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"] as const;

const OrderListSettingsPanel = ({ draftSettings, activeCategories, open, saving, error, onClose, onSave, onChange }: Props): JSX.Element | null => {
  if (!open) {
    return null;
  }

  const updateSetting = (id: string, update: Partial<OrderListDeliverySetting>): void => {
    onChange(draftSettings.map(setting => setting.id === id ? { ...setting, ...update } : setting));
  };

  return <section className="order-list-settings-panel" aria-label="Delivery settings">
    {draftSettings.map(setting => <div className="order-list-setting-editor" key={setting.id}>
      <div className="order-list-setting-editor__topline">
        <input aria-label="Setting name" value={setting.name} onChange={event => updateSetting(setting.id, { name: event.target.value })} />
        <label><input type="checkbox" checked={setting.active} onChange={event => updateSetting(setting.id, { active: event.target.checked })} /> Active</label>
      </div>
      <div className="order-list-setting-editor__choices">
        <fieldset><legend>Categories</legend>
          {activeCategories.map(value => <label key={value}><input type="checkbox" checked={setting.categories.includes(value)} onChange={event => updateSetting(setting.id, { categories: event.target.checked ? [...setting.categories, value] : setting.categories.filter(category => category !== value) })} /> {value}</label>)}
        </fieldset>
        <fieldset><legend>Delivery days</legend>
          {deliveryDays.map(value => <label key={value}><input type="checkbox" checked={setting.deliveryDays.includes(value)} onChange={event => updateSetting(setting.id, { deliveryDays: event.target.checked ? [...setting.deliveryDays, value] : setting.deliveryDays.filter(day => day !== value) })} /> {value}</label>)}
        </fieldset>
      </div>
    </div>)}
    {error && <Message type="error" showIcon>
      <div>Settings could not be saved.</div>
      <ul>{getOrderListSettingsErrors(error).map(message => <li key={message}>{message}</li>)}</ul>
    </Message>}
    <Button appearance="primary" loading={saving} onClick={() => onSave(draftSettings)}>Save delivery settings</Button>
    <Button appearance="subtle" onClick={onClose}>Close settings</Button>
  </section>;
};

export default OrderListSettingsPanel;